import React from 'react';
import PropTypes from 'prop-types';
import SeoLandingPage from '@components/seo-landing-page';

const page = {
  seoTitle: 'Consultant Flutter Kotlin iOS | Hedi Hidouri',
  seoDescription:
    'Consultant Flutter, Kotlin et iOS pour concevoir et livrer des plateformes mobiles securisees, du MVP a l echelle, avec architecture durable et automatisation des releases.',
  overline: 'Consultant Flutter Kotlin iOS',
  heading: 'Consultant pour le delivery Flutter, Kotlin et iOS',
  intro: [
    'J aide les equipes a choisir et mettre en oeuvre la bonne approche entre Flutter, natif Android/iOS et Kotlin Multiplatform selon les contraintes produit.',
    'Objectif: delivery fiable, codebase maintenable et roadmap technique alignee avec la croissance business.',
  ],
  offerTitle: 'Perimetre de conseil',
  offerItems: [
    'Blueprint d architecture pour Flutter, Kotlin, Swift et modules partages.',
    'Baseline qualite avec strategie de tests et standards CI/CD.',
    'Amelioration des performances et de la stabilite sur applications existantes.',
    'Leadership technique pour cadrage et execution roadmap.',
  ],
  outcomesTitle: 'Impacts business',
  outcomeItems: [
    'Moins de risque technique sur les initiatives mobiles strategiques.',
    'Trajectoire claire de modernisation depuis des architectures legacy.',
    'Meilleur alignement entre produit, design, backend et mobile.',
    'Processus de livraison production-ready avec quality gates mesurables.',
  ],
  primaryCta: 'Lancer une discussion technique',
  secondaryCta: 'Voir Developpeur Mobile Senior',
  secondaryCtaUrl: '/fr/senior-mobile-developer',
  faqTitle: 'FAQ',
  faq: [
    {
      question: 'Quand choisir Flutter plutot que natif ?',
      answer:
        'Le choix depend des contraintes produit, des competences equipe et de la roadmap. Je structure la decision selon le compromis vitesse, qualite et maintenabilite.',
    },
    {
      question: 'Intervenez-vous aussi sur le backend mobile ?',
      answer:
        'Oui, surtout sur les couches backend et API orientees mobile lorsque les APIs doivent etre adaptees pour la performance et la fiabilite.',
    },
    {
      question: 'Peut-on ameliorer une app existante sans refonte totale ?',
      answer:
        'Oui. La majorite des missions sont des modernisations incrementales avec un plan priorise qui preserve le delivery.',
    },
  ],
  relatedTitle: 'Pages liees',
  relatedLinks: [
    { label: 'Developpeur mobile senior a Paris', url: '/fr/senior-mobile-developer' },
    { label: 'Section expertises principale', url: '/fr#services' },
    { label: 'Contact mission', url: '/fr#contact' },
  ],
  serviceSchema: {
    name: 'Conseil Flutter Kotlin iOS',
    serviceType: 'Conseil en architecture et delivery mobile',
  },
};

const FlutterKotlinIosConsultantPageFr = ({ location }) => (
  <SeoLandingPage location={location} language="fr" page={page} />
);

FlutterKotlinIosConsultantPageFr.propTypes = {
  location: PropTypes.object.isRequired,
};

export default FlutterKotlinIosConsultantPageFr;
